import React, { useEffect } from "react";
import { useImmer } from "use-immer";
import { useOpenBookScopeContext } from "../../../master";
import { NiModal } from "@nergy-ui/practicetool";
import "@nergy-ui/practicetool/styles";

export const SubmitMsg = () => {
    const {
        openBookState,
        setOpenBookState,
        afterTaskComplete,
        validateLoading,
    } = useOpenBookScopeContext();
    const [ans, setAns] = useImmer({
        correct: [],
        conclusionErr: false,
    });

    useEffect(() => {
        if (!openBookState.validateLoading && openBookState.validateResponse) {
            setAns((draft) => {
                draft.correct =
                    openBookState?.validateResponse?.answerOrders[0]?.answerOrders || [];
                draft.conclusionErr = openBookState.validateResponse?.errors.some(
                    (err) => {
                        return err.key.includes("conclusion");
                    }
                );
            });
        }
    }, [openBookState.validateLoading, openBookState.validateResponse]);

    const checkAllValid = () => {
        const cErr = openBookState.qn.conclusions?.length > 0
            ? openBookState.conclusion && !ans.conclusionErr
            : true;
        if (ans.correct.length === openBookState.provisionsCount && cErr) {
            return true;
        }
        return false;
    };

    let conclusionCheck = openBookState.qn.conclusions?.length > 0;

    const isSuccess = checkAllValid() ? true : false;

    const maxAttempt = openBookState?.validateResponse?.maxAttempt;
    const remainingAttempts = openBookState?.validateResponse?.remainingAttempts;
    const progressValue = openBookState?.validateResponse?.progress;
    const isProgressNumber = !isNaN(Number(progressValue));

    const progress = {
        maxAttempt: maxAttempt ? maxAttempt : 0,
        remainingAttempts: remainingAttempts ? remainingAttempts : 0,
        progressValue:
            progressValue && isProgressNumber ? Number(progressValue).toFixed(0) : 0,
        progressLabel: isProgressNumber
            ? `${Number(progressValue).toFixed(0)}%`
            : "0%",
        isProgressBarVisible: maxAttempt || remainingAttempts,
    };

    const isAttemptOver =
        openBookState?.validateResponse?.remainingAttempts === 0;

    return (
        <>
            {!isSuccess && !validateLoading && (
                <NiModal
                    type="error"
                    isOpen={true}
                    title="Error found"
                    descrption={
                        <div className="custom-error-div">
                            <p>
                                {ans.correct.length} out of {openBookState.provisionsCount}{" "}
                                provisions are correct!
                            </p>
                            {conclusionCheck && !openBookState.conclusion && (
                                <p>Please select conclusion</p>
                            )}
                            {conclusionCheck &&
                                openBookState.conclusion &&
                                ans.conclusionErr && <p>Incorrect conclusion!</p>}
                        </div>
                    }
                    buttonText={isAttemptOver ? "Close" : "Try Again!"}
                    progress={progress}
                    onConfirm={
                        isAttemptOver
                            ? afterTaskComplete
                            : () => {
                                setOpenBookState((draft) => {
                                    draft.isSubmitted = false;
                                });
                            }
                    }
                />
            )}
            {isSuccess && !validateLoading && (
                <NiModal
                    type="success"
                    isOpen={true}
                    title="Congratulations !"
                    descrption="You’ve completed the task correctly."
                    buttonText="Done"
                    onConfirm={afterTaskComplete}
                    progress={progress}
                />
            )}
        </>
    );
};
